var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mode === 'edit')?_c('delivery-settings',{on:{"change-mode":_vm.changeMode}}):_vm._e(),_vm._v(" "),(_vm.mode === 'query')?_c('delivery-setting-list',{on:{"change-mode":_vm.changeMode}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f332cba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/apply-for-manage/base-setting/deliverySetting.vue
// module id = null
// module chunks = 